export default "__VITE_ASSET__6de32aac__"